var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modals !== null)?_c('div',[_c('UserBanModal',{attrs:{"modal-data":_vm.modals.userBanModal},on:{"close":_vm.closeNotification}}),_vm._v(" "),_c('SimpleModal',{attrs:{"modal-data":_vm.modals.simpleModal},on:{"close":_vm.closeNotification}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }